// extracted by mini-css-extract-plugin
export var cardWrapper = "_5f-0";